@if(formGroup && formGroup.get('collectFrom') !== null){
<form [formGroup]="getFormGroup()">
  <div class="p-2">
    <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
      Collect From Information
    </div>
    <div class="m-4 mt-3">
      <app-address-picker [formGroup]="getFormGroup()" label="Collect From" [showPreciseLocationOptions]="true" preciseLocationLabel="Collect From Location"></app-address-picker>
      <div class="col-12">
        <div class="row mb-1">
          <label class="col-3 mt-2 text-start mogo-bold" for="pickup-open-input">Pickup Open Date:</label>
          <div class="col-9" formGroupName="pickupOpen">
            <div class="row">
              <div class="col-8">
                <div class="input-group">
                  <input class="form-control" placeholder="Pickup Open" name="dp" formControlName="date"
                    removeNgbDpDefaultValidation ngbDatepicker #pickupDatePicker="ngbDatepicker"
                    id="pickup-open-date-input" autocomplete="off"/>
                  <button class="btn btn-outline-secondary py-1" (click)="pickupDatePicker.toggle()"
                    [disabled]="lockdown" type="button">
                    <ng-icon name="bootstrapCalendarFill" size></ng-icon>
                  </button>
                </div>
              </div>
              <div class="col-4">
                <ngb-timepicker id="pickup-open-time-picker" [size]="'small'" formControlName="time" [meridian]="true"
                  [spinners]="false"></ngb-timepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-3 mt-2 text-start mogo-bold" for="pickup-close-input">Pickup Close Date:</label>
          <div class="col-9" formGroupName="pickupClose">
            <div class="row">
              <div class="col-8">
                <div class="input-group">
                  <input class="form-control" placeholder="Pickup Close" name="dp" formControlName="date"
                    removeNgbDpDefaultValidation ngbDatepicker #pickupCloseDatePicker="ngbDatepicker"
                    id="pickup-close-date-input" autocomplete="off"/>
                  <button class="btn btn-outline-secondary py-1" (click)="pickupCloseDatePicker.toggle()"
                    [disabled]="lockdown" type="button">
                    <ng-icon name="bootstrapCalendarFill" size></ng-icon>
                  </button>
                </div>
              </div>
              <div class="col-4">
                <ngb-timepicker id="pickup-close-time-picker" [size]="'small'" formControlName="time" [meridian]="true"
                  [spinners]="false"></ngb-timepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-3 mt-2 text-start mogo-bold">Site Contact:</label>
          <div class="col-9">
            <input id="site-contact-input" type="text" class="form-control" formControlName="siteContact"
              placeholder="Site Contact" (change)="siteContactNameAltered()"/>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-3 mt-2 text-start mogo-bold">Contact Phone:</label>
          <div class="col-9">
            <input id="site-contact-input" type="text" class="form-control" formControlName="siteContactPhone"
              placeholder="Contact Phone" (change)="siteContactPhoneAltered()"/>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-3 mt-2 text-start mogo-bold">Contact Email:</label>
          <div class="col-9">
            <input id="site-contact-input" type="text" class="form-control" formControlName="siteContactEmail"
              placeholder="Contact Email" />
              @if(formGroup.get('collectFrom')?.get('siteContactEmail')?.invalid && formGroup.get('collectFrom')?.get('siteContactEmail')?.touched){
                <div class="text-start">
                  <small class="text-danger">Please enter a valid email address</small>
                </div>
              }
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
}
